import React, { useEffect, useState } from 'react';
import { PageLayout, TabSet, TabSetContent, useTabSet } from '../layout';
import { Paper } from '@mui/material';
import { compose } from 'recompose';
import { withFirebase } from '../Firebase';
import { withAuthorization, withEmailVerification } from '../Session';
import * as ROLES from '../../constants/roles';
import Subscription from './subscription';
import Locations from './locations';
import Company from './company/';
import Users from './users';
import ApiKeys from './apiKeys';
import { useCompany, useLocations } from '../../providers';

const baseTabNames = ['Company', 'Locations', 'Users', 'Subscription'];

const SettingsPage = (props) => {
   const { company } = useCompany();
   const { allLocations, archivedLocations, getObjectAsArray } = useLocations();
   const [tabValue, setTabValue, handleTabChange] = useTabSet();

   // The CompanyProvider strips `features.api` (it only keeps known featureSet
   // keys), so read the raw flag to decide whether to show the API tab. This
   // keeps the API a beta feature visible only to enabled companies.
   const [apiEnabled, setApiEnabled] = useState(false);
   const cid = company?.cid;
   useEffect(() => {
      if (!cid) return undefined;
      let active = true;
      props.firebase
         .company(cid)
         .get()
         .then((doc) => {
            if (active) setApiEnabled(!!doc.data()?.features?.api);
         })
         .catch(() => {
            if (active) setApiEnabled(false);
         });
      return () => {
         active = false;
      };
   }, [props.firebase, cid]);

   const locations = getObjectAsArray(allLocations);
   const archivedLocationsArray = getObjectAsArray(archivedLocations);

   const tabNames = apiEnabled ? [...baseTabNames, 'API'] : baseTabNames;
   const contentArray = [
      <Company company={company} locations={locations} setValue={setTabValue} />,
      <Locations
         company={company}
         locations={locations}
         archivedLocations={archivedLocationsArray}
      />,
      <Users tab={tabValue} />,
      <Subscription tab={tabValue} />,
   ];
   if (apiEnabled) {
      contentArray.push(<ApiKeys company={company} apiEnabled={apiEnabled} />);
   }

   return (
      <PageLayout>
         <Paper elevation={0}>
            <TabSet value={tabValue} onChange={handleTabChange} tabNames={tabNames} />

            {company && (
               <TabSetContent
                  tabValue={tabValue}
                  tabNames={tabNames}
                  contentArray={contentArray}
               />
            )}
         </Paper>
      </PageLayout>
   );
};

const condition = (authUser) => authUser && !!authUser.roles[ROLES.ADMIN];

export default compose(
   withEmailVerification,
   withAuthorization(condition),
   withFirebase,
)(SettingsPage);
